import type { Actor } from '@/lib/directory';
import { Avatar } from './avatar';
import styles from './avatar-stack.module.css';

/**
 * An overlapping face-pile of actors (the multi-contributor / multi-party display): up to
 * `max` avatars, then a "+N" overflow chip. One avatar renders as a plain avatar. Server-safe
 * and presentational, like `Avatar` itself. `titles={false}` suppresses the per-face native
 * titles - pass it when a house `Tooltip` on an ancestor already names everyone.
 */
export function AvatarStack({
  actors,
  size = 20,
  max = 3,
  titles = true,
}: {
  actors: Actor[];
  size?: number;
  max?: number;
  titles?: boolean;
}) {
  const shown = actors.slice(0, max);
  const more = actors.length - shown.length;
  return (
    <span className={styles.stack}>
      {shown.map((a) => (
        <span key={a.ref} className={styles.face}>
          <Avatar actor={a} size={size} title={titles ? undefined : false} />
        </span>
      ))}
      {more > 0 && (
        <span className={styles.more} style={{ height: size, minWidth: size }}>
          +{more}
        </span>
      )}
    </span>
  );
}
